const MIGRATION_BASE_URL = `${process.env.REACT_APP_PERMISSIONS_API_URL}/site-group/message-migration`;

export const MIGRATION_STATUSES = ['Done', 'To Do', 'Wont Do'];

// Read per-message migration metadata. Returns {} when nothing is stored yet.
export const getMessageMigration = async (messageId) => {
  const res = await fetch(`${MIGRATION_BASE_URL}?messageId=${encodeURIComponent(messageId)}`, {
    headers: { Accept: 'application/json' },
    credentials: 'include',
  });
  if (!res.ok) throw new Error(`Failed to load migration metadata (${res.status})`);
  return res.json();
};

// Write migration metadata. Only the fields passed are updated; omitted fields
// keep their previously stored value. Relies on the token cookie for auth.
export const updateMessageMigration = async (messageId, { lastMigratedDate, migrationStatus } = {}) => {
  const body = {};
  if (lastMigratedDate !== undefined) body.lastMigratedDate = lastMigratedDate;
  if (migrationStatus !== undefined) body.migrationStatus = migrationStatus;

  const res = await fetch(`${MIGRATION_BASE_URL}?messageId=${encodeURIComponent(messageId)}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`Failed to update migration metadata (${res.status})`);
  return res.json();
};

// `localization`, when present, carries the message's translated copy so the
// conversion can key its content maps by more than the screenshot's language.
// Optional by design — a single-language message omits it and the conversion
// behaves exactly as before.
//
// `messageId` is sent as `spMessageId` so feedback on the converted widget can be
// traced back to the Sourcepoint message it came from.
//
// `widgetType` selects the Didomi widget Consent Vision produces; omitted, it is the
// web consent notice. Native OTT messages send 'ctv'.
export const migrate = async (orgId, layers, name, localization, messageId, widgetType) => {
  let success
  try {
    const resp = await fetch(`${process.env.REACT_APP_PERMISSIONS_API_URL}/consent-vision/conversions`, {
      method: 'POST',
      credentials: 'include',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ddm_organization_id: orgId,
        layers,
        mode: "thorough",
        // webhookUrl: "https://example.com/webhooks/conversions",
        createDraft: true,
        name,
        spMessageId: String(messageId),
        ...(widgetType ? { widgetType } : {}),
        // The language the layers were captured in, so Consent Vision labels the
        // generated copy from the message settings instead of inferring it from
        // the screenshot.
        ...(localization?.defaultLanguage ? { language: localization.defaultLanguage } : {}),
        ...(localization ? { localization } : {}),
      }),
    })

    const { conversionId, error, reason, statusCode } = await resp.json()

    if (conversionId) {
      return { success: true }
    }

    if (statusCode === 500) {
      return {
        success: false,
        error: { internalServerError: true }
      }
    }

    if (error && error === 'preflight_rejected') {
      return {
        success: false,
        error: { preflightFailed: reason }
      }
    }
  } catch (error) {
    return { success: false, error }
  }
}